import get from "lodash/get"
import { Component } from "react"
import PropTypes from "prop-types"
import isIE from "utils-lib/isIE"
import getAlertVersion from "utils-lib/alerts"
import { ButtonArrow, GenericModal } from "../../../../../Base"
import "./BrowserAlert.scss"

const ALERT_VERSION = getAlertVersion()
const LOCAL_STORAGE_KEY = `${ALERT_VERSION}-alreadyVisited`

class BrowserAlert extends Component {
  constructor(props) {
    super(props)
    // TODO: Improve and refactor the code
    this.state = {
      isVisible: isIE(),
    }
  }

  isNotificationHidden = (subtext) => {
    const visitedAlerts = localStorage.getItem(LOCAL_STORAGE_KEY)

    let parseVisitedAlerts = {}
    if (visitedAlerts) {
      try {
        parseVisitedAlerts = JSON.parse(visitedAlerts)

        const hasAlertBeenSeen = get(parseVisitedAlerts, subtext, false)

        if (hasAlertBeenSeen) {
          return true
        }
      } catch {
        /* do nothing, use default parseVisitedAlerts value */
      }
      return false
    }
    return false
  }

  hideNotification(subtext) {
    const visitedAlerts = localStorage.getItem(LOCAL_STORAGE_KEY)

    let newVisitedAlerts = { [subtext]: true }
    if (visitedAlerts) {
      try {
        newVisitedAlerts = { ...newVisitedAlerts, ...JSON.parse(visitedAlerts) }
      } catch (e) {
        /* do nothing, use default newVisitedAlerts value */
      }
    }

    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newVisitedAlerts))

    this.setState(
      {
        isVisible: false,
      },
      () => {
        this.props.onAlertClose()
      },
    )
  }

  render() {
    if (this.props.browserAlerts) {
      const { title, linktext, href, subtext } = this.props.browserAlerts

      return (
        <div data-testid="BrowserAlert">
          <GenericModal
            open={
              this.state.isVisible &&
              subtext &&
              !this.isNotificationHidden(subtext)
            }
            onClose={() => {
              this.hideNotification(subtext, title)
            }}
            customDialogueClass="p-0"
            useFlexibleWidth
            showCloseButton
          >
            <div className="BrowserAlert maax-font-weight-regular">
              <div
                className="maax-font-weight-bold font-sm text-center py-2 px-3"
                style={{
                  background: "#E7F7E8",
                }}
              >
                {title}
              </div>
              <div className="p-4">
                <div className="text-center wm-grey-light font-sm mb-4">
                  {subtext}
                </div>
                {linktext && href && (
                  <ButtonArrow
                    className="linkText d-flex justify-content-center align-items-center maax-font-weight-bold wm-link"
                    href={href}
                    isExternalLink
                  >
                    {linktext}
                  </ButtonArrow>
                )}
              </div>
            </div>
          </GenericModal>
        </div>
      )
    }
    return null
  }
}

BrowserAlert.propTypes = {
  browserAlerts: PropTypes.object.isRequired,
  onAlertClose: PropTypes.func.isRequired,
}

export default BrowserAlert
